export const SELECTED_NFTS = "selectedNfts";
